module.exports = __webpack_public_path__ + "img/glassquality_5.f0cc341e.png";